export interface SectionHeadingProps {
  text: string;
  textColor?: string;
  className?: string;
}

const SectionHeading = ({
  text,
  textColor = "text-cultiv-red",
  className,
}: SectionHeadingProps) => {
  return (
    <h2 className={`text-xl xl:text-4xl uppercase font-xExpandedBold ${textColor} ${className}`}>
      {text}
    </h2>
  );
};

export default SectionHeading;
